<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Transporteurs</h1>
                    <p>Gestion des méthodes de paiements</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.transporter.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un transporteur</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" active-advanced-filter="false" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div>
                          <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Référence', value:'ref'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div><span>Statut</span></div>
                        <div><span>Scopes</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxcore.transporter.view', item.id )">
                        <div></div>
                        <div class="picture no-radius">
                            <figure>
                                <i v-if="!item.picture" class="icon icon-icon_truck-delivery-time" style="font-size: 1.5em;"></i>
                                <img v-if="item.picture" :src="item.picture.url+'/resize/100x100'"/>
                            </figure>
                        </div>
                        <div data-field="name"><strong class="highlight">{{ item.name }}</strong><p>{{ item.headline }}</p></div>
                        <div data-field="ref">{{ item.slug }}</div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="actions">
                            <ul>
                                <li v-if="$aclInterfaceValidator('weeboxcore.transporter.delete',item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-if="$aclInterfaceValidator('weeboxcore.transporter.update',item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import TransporterService from './TransporterService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return TransporterService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/transporter/Index.vue